module.exports = __webpack_public_path__ + "static/media/居民住宅一体化供暖2.bd3d06fb.jpg";